import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowLeft } from 'react-icons/fa';
import { services } from '../data/services';
import Footer from './Footer';
import '../Styling/Services.css';
import ServiceCard from './ServiceCard';

const Services = () => {
  useEffect(() => {
    document.title = 'Our Services - Global Excellence';
    window.scrollTo(0, 0);
  }, []);

  return (
    <motion.div 
      className="services-wrapper"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <motion.section 
        className="services-hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <motion.h1 
          className="services-title"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Our Services
        </motion.h1>
        <motion.p 
          className="services-subtitle"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          Comprehensive solutions tailored to your business needs
        </motion.p>
      </motion.section>

      <section className="services-grid">
        {services.map((service) => (
          <ServiceCard key={service.id} service={service} />
        ))}
      </section>

      <section className="services-cta">
        <motion.div 
          className="cta-content"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="cta-title">Ready to Get Started?</h2>
          <p className="cta-subtitle">Let's discuss how we can help transform your business</p>
          <Link to="/contactus" className="cta-button">
            Contact Us <span className="button-arrow">→</span>
          </Link>
        </motion.div>
      </section>
      <Footer />
    </motion.div>
  );
};

export default Services; 